import {
  HTTP_CP_SignUp_Request_Mortgage,
  HTTP_CP_SignUp_Request_Mortgage_MortgagePart_MortgagePartFromData,
  HTTP_CP_SignUp_Request_Mortgage_MortgagePart_MortgagePartFromMortgageProduct,
} from '@api-new/authservice';
import { MortgageFormValues } from '@app/sign-up/forms/mortgage.form';
import { SKIPPED_PRODUCT_MATCH_PLACEHOLDER } from '@client-ui/components/forms/mortgage-product-match-form/mortgage-product-match-form.component';
import { dateToIsoStringWithoutTimezone } from '@shared-lib/utils/date-utils/date-to-iso-string-without-timezone';
import dayjs from 'dayjs';

export const signUpMortgageToHttpRequestAdapter = (mortgage: MortgageFormValues | null): HTTP_CP_SignUp_Request_Mortgage | undefined => {
  if (mortgage == null) return undefined;

  return {
    lenderId: mortgage.lenderAndStartDate.lenderId,
    mortgageParts: mortgage.mortgageParts.parts.map((part, index) => {
      const mortgagePartFromMortgageProduct: HTTP_CP_SignUp_Request_Mortgage_MortgagePart_MortgagePartFromMortgageProduct | undefined =
        mortgage.productMatch.partsMortgageProductIds[index] !== SKIPPED_PRODUCT_MATCH_PLACEHOLDER
          ? {
              mortgageProductId: mortgage.productMatch.partsMortgageProductIds[index],
              startDate: dateToIsoStringWithoutTimezone(part.startDate) ?? undefined,
              endDate: dateToIsoStringWithoutTimezone(dayjs(part.startDate).add(part.term, 'month')) ?? undefined,
            }
          : undefined;

      const mortgagePartFromData: HTTP_CP_SignUp_Request_Mortgage_MortgagePart_MortgagePartFromData | undefined =
        mortgage.productMatch.partsMortgageProductIds[index] === SKIPPED_PRODUCT_MATCH_PLACEHOLDER
          ? {
              initialMortgagePartStepType: part.initialRateType ?? mortgage.rateTypeAndRatePeriod.initialRateType,
              initialPeriodEndDate:
                dateToIsoStringWithoutTimezone(
                  dayjs(part.startDate)
                    .add(part.initialRatePeriod ?? mortgage.rateTypeAndRatePeriod.initialRatePeriod, 'month')
                    .toISOString(),
                ) ?? undefined,
              startDate: dateToIsoStringWithoutTimezone(part.startDate) ?? undefined,
              endDate: dateToIsoStringWithoutTimezone(dayjs(part.startDate).add(part.term, 'month')) ?? undefined,
              initialInterestRate: part.initialInterestRate ?? mortgage.monthlyPayment.rate! / 100,
            }
          : undefined;

      return {
        initialAmount: part.borrowedAmount,
        repaymentType: part.repaymentType,
        isFurtherAdvance: part.isFurtherAdvance,
        mortgagePartFromMortgageProduct,
        mortgagePartFromData,
      };
    }),
  };
};
